export enum STATUSES {
  TRAVEL_INSURANCE = 0,
  TRAVEL_INFO = 1,
  QUOTE_LIST = 2,
  PASSPORT_INFO = 3,
  SUMMARY_AND_PAYMENT = 4,
}
